import { RecommendedEntriesPerPageTypes } from '../types';
import { SET_RECOMMENDED_ENTRIES_PER_PAGE } from '../constants/actionTypes';

export const setRecommendedEntriesPerPage = (
  currentRecommendedEntriesPerPage: number,
): RecommendedEntriesPerPageTypes => ({
  type: SET_RECOMMENDED_ENTRIES_PER_PAGE,
  payload: currentRecommendedEntriesPerPage,
});
